import { resolvePostAuthDestination } from './safeReturn';

export const SESSION_EXPIRED_EVENT = 'pinpoint:session-expired';
export const ACCESS_PENDING_RETURN_PATH = '/access-pending';

export type SessionExpiredDetail = { returnTo: string };

/** Keep expiry recovery on a reviewed Product route; reject external and legacy paths. */
export function resolveSessionExpiryDestination(candidate: string | null | undefined): string {
  if (candidate === ACCESS_PENDING_RETURN_PATH) return ACCESS_PENDING_RETURN_PATH;
  return resolvePostAuthDestination(candidate);
}

export function buildSessionExpiredLoginPath(candidate: string | null | undefined): string {
  const returnTo = resolveSessionExpiryDestination(candidate);
  return `/login?reason=session-expired&next=${encodeURIComponent(returnTo)}`;
}

function currentProductPath(): string {
  if (typeof window === 'undefined') return '/practice';
  return `${window.location.pathname || ''}${window.location.search || ''}${window.location.hash || ''}`;
}

/**
 * Invalidate credentials before notifying React to remove its protected tree.
 *
 * Terminal API responses can race. Only the first response for the currently
 * stored credential owns expiry; later responses must not replace its return
 * path or invalidate a newly installed credential.
 */
export function expireProductSession(
  candidate: string | null | undefined = currentProductPath(),
  expectedAccessToken?: string | null,
): boolean {
  const returnTo = resolveSessionExpiryDestination(candidate);
  const currentAccessToken = window.localStorage?.getItem('access_token') ?? null;
  if (expectedAccessToken !== undefined && currentAccessToken !== expectedAccessToken) return false;
  window.localStorage?.removeItem('access_token');
  window.localStorage?.removeItem('auth_token');
  if (currentAccessToken === null) return false;
  window.dispatchEvent(new CustomEvent<SessionExpiredDetail>(SESSION_EXPIRED_EVENT, {
    detail: { returnTo },
  }));
  return true;
}
